import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-logo-box',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [class]="className">
      <a href="index.html" class="logo-dark">
        <img
          src="assets/images/logo.png"
          [ngClass]="className == 'logo-box' ? 'logo-sm' : 'me-1'"
          [height]="logoHeight"
          alt="logo sm"
        />
      </a>

      <a href="index.html" class="logo-light">
        <img
          src="assets/images/logo.png"
          [ngClass]="className == 'logo-box' ? 'logo-sm' : 'me-1'"
          [height]="logoHeight"
          alt="logo sm"
        />
      </a>
    </div>
  `,
})
export class LogoBoxComponent {
  @Input() className: string = ''
  @Input() height: string = ''
  @Input() logoHeight: string = ''
}
